import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";

export default function TipTapLinkModal({ editor, onClose }) {
	const { t } = useTranslation();
	const currentUrl = editor.getAttributes("link").href || "";
	const [url, setUrl] = useState(currentUrl);
	const inputRef = useRef(null);

	useEffect(() => {
		inputRef.current?.focus();
	}, []);

	const handleSubmit = (e) => {
		e.preventDefault();
		if (url.trim() === "") {
			editor.chain().focus().extendMarkRange("link").unsetLink().run();
		} else {
			editor
				.chain()
				.focus()
				.extendMarkRange("link")
				.setLink({ href: url })
				.run();
		}
		onClose();
	};

	return createPortal(
		<div className="tiptap-link-modal-overlay" onClick={onClose}>
			<form
				className="tiptap-link-modal"
				onClick={(e) => e.stopPropagation()}
				onSubmit={handleSubmit}
			>
				<label className="tiptap-link-modal__label">
					{t("editor.linkUrl", "URL")}
				</label>
				<input
					className="tiptap-link-modal__input"
					type="url"
					placeholder="https://"
					value={url}
					onChange={(e) => setUrl(e.target.value)}
					ref={inputRef}
				/>
				<div className="tiptap-link-modal__actions">
					<button
						type="button"
						className="tiptap-link-modal__btn tiptap-link-modal__btn--cancel"
						onClick={onClose}
					>
						{t("commands.cancel", "Anuluj")}
					</button>
					<button
						type="submit"
						className="tiptap-link-modal__btn tiptap-link-modal__btn--confirm"
					>
						{t("commands.confirm", "Zapisz")}
					</button>
				</div>
			</form>
		</div>,
		document.body,
	);
}
